// ======================== SELECT ======================== //
const GET_USERS = `
query GetUsers {
  users(order_by: {id: asc}, where: {is_activated: {_eq: true}}) {
    id
    username
    gender
    fullname
    email
    created_at
    cover
    avatar
    phone_number
    userquotes
    birthday
    type_user
    school_id
    grade_id
    name_color
    is_activated
    is_show_email
    is_show_phone
    is_show_birthday
  }
}
`
const GET_PROFILE = `
query GetUser($uid: String!) {
  users(where: {id: {_eq: $uid}}) {
    id
    username
    gender
    fullname
    email
    created_at
    cover
    avatar
    phone_number
    userquotes
    birthday
    type_user
    school_id
    grade_id
    name_color
    is_activated
    is_show_email
    is_show_phone
    is_show_birthday
    social_type
    rank_id
    rank {
      name
      id
    }
  }
}
`
const COUNT_EMAIL_ACCOUNT = `
query countEmails($email: String) {
  v_user_public_aggregate(where: {email: {_eq: $email}}) {
    aggregate {
      count
    }
    nodes {
      id
    }
  }
}
`
const GET_FULLNAME = `
query getFullName($uid: String!) {
  v_user_public(where: {id: {_eq: $uid}}) {
    avatar
    cover
    email
    fullname
    id
    name_color
    type_user
    username
    rank_id
  }
}
`
const GET_USER_PUBLIC = `
query GetUser($username: String!) {
  v_user_public(where: {username: {_eq: $username}}) {
    avatar
    cover
    email
    fullname
    id
    name_color
    type_user
    username
  }
}
`
const GET_GRADES = `
query GetGrades {
  grades(order_by: {id: desc}, where: {is_delete: {_eq: false}}) {
    id
    name
    description
    type_grade
  }
}
`
const GET_GRADE_ID = `
query getGrade ($gid: Int) {
  grades(where: {is_delete: {_eq: false}, id: {_eq: $gid}}) {
    id
    name
  }
}
`
const GET_SCHOOLS = `
query GetSchool {
  school(order_by: {id: asc}, where: {is_delete: {_eq: false}}) {
    id
    name
    teach_grade
  }
}
`
const GET_SCHOOL_ID = `
query getSchool ($sid: Int) {
  school(where: {is_delete: {_eq: false}, id: {_eq: $sid}}) {
    id
    name
  }
}
`
const GET_SUBJECTS = `
query GetSubjects {
  subjects(order_by: {id: desc}, where: {is_delete: {_eq: false}}) {
    id
    name
    description
    icon
  }
}`
const GET_SUBJECTS2 = `
query GetSubjects($where: subjects_bool_exp, $orderBy: [subjects_order_by!]) {
  subjects(order_by: $orderBy, where: $where) {
    id
    name
    description
    icon
  }
}`
const GET_ACHIEVES = `
query GetAchieve {
  achievement (order_by: {id: desc}, where: {is_delete: {_eq: false}}) {
    id
    name
    icon
    created_at
    updated_at
  }
}
`
const GET_HIGHLIGHT_USER = `
query GetHighlight($user_id: String!) {
  achievement(where: {
      achievement_users: {user_id: {_eq: $user_id}
    }, is_delete: {_eq: false}}, order_by: {id: desc}) {
    id
    name
    icon
  }
}
`
const GET_LESSONS = `
query getLessons {
  lesson (order_by: {id: asc}, where: {is_delete: {_eq: false}}){
    id
    name
    content
    created_at
    updated_at
    thumbnail
    grade {
      name
    }
    subject {
      name
    }
    category {
      name
    }
  }
}
`
const GET_FIRST_LESSON = `
query getfirstLesson($id: Int!) {
  lesson ( where: {id: {_eq: $id}}){
    banner
    category_id
    content
    created_at
    created_by
    thumbnail
    files
    grade_id
    id
    is_delete
    link_video
    name
    read
    subject_id
    teacher_id
    type_lesson
    updated_at
    updated_by
    is_public
    is_public_pc
    userCreate {
      fullname
    }
    userUpdate {
      fullname
    }
  }
}
`
const GET_FIRST_LESSON2 = `
query getfirstLesson2($where: lesson_bool_exp) {
  lesson(where: $where){
    banner
    category_id
    content
    created_at
    created_by
    thumbnail
    files
    grade_id
    id
    is_delete
    link_video
    name
    read
    subject_id
    teacher_id
    type_lesson
    updated_at
    updated_by
    is_public
    is_public_pc
    is_complete
    userCreate {
      fullname
    }
    userUpdate {
      fullname
    }
    lesson_grades {
      grade {
        id
        name
      }
    }
    lesson_classes {
      class_id
      class {
        id
        name
      }
    }
  }
}
`
const GET_CLASS_LESSON = `
query getclassLesson($id: bigint!) {
  lesson_class ( where: {lesson_id: {_eq: $id}}){
    class {
      name
      id
    }
  }
}
`
function GET_LESSONS_FILTER(filtered, offset, limit) {
  return `
  query getLessons {
    lesson (limit: ${limit}, offset: ${offset}, order_by: {updated_at: desc}, where: ${filtered}){
      id
      name
      content
      link_video
      is_public
      created_at
      updated_at
      thumbnail
      grade {
        name
      }
      subject {
        name
      }
      category {
        name
      }
    }
  }`
}
const GET_FOLLOWING = `
query GetFollowers($uid: String!, $keyword: String) {
  followes_aggregate(where: {user_id_follow: {_eq: $uid}, userFollowed: {fullname: {_ilike: $keyword}}}) {
    aggregate {
      count
    }
    nodes {
      userFollowed {
        id
        fullname
        avatar
      }
    }
  }
}
`
const GET_FOLLOWED = `
query GetFollowers($uid: String!, $keyword: String) {
  followes_aggregate(where: {user_id_followed: {_eq: $uid}, userFollow: {fullname: {_ilike: $keyword}}}) {
    aggregate {
      count
    }
    nodes {
      userFollow {
        id
        fullname
        avatar
      }
    }
  }
}
`
const GET_STRENGTH = `
query getStrength($user_id: String!) {
  subject_user(where: {user_id: {_eq: $user_id}, subject: {is_delete: {_eq: false}}}, order_by: {subject: {id: asc}}) {
    subject {
      id
      name
      icon
    }
  }
}
`
const GET_SUBJECT_USER = `
query GetSubjecUser($where: subject_user_bool_exp, $orderBy: [subject_user_order_by!]) {
  subject_user(order_by: $orderBy, where: $where) {
    subject {
      id
      name
      icon
    }
  }
}`
const GET_CATEGORY = `
query getCategory {
  category(where: {is_deleted: {_eq: false}}, order_by: {name: asc}) {
    name
    note
    id
  }
}
`
const COUNT_POINT_USER = `
query SumPoint($uid: String, $type: Int!) {
  history_point_aggregate(where: {user_id: {_eq: $uid}, type_point: {_eq: $type}}) {
    aggregate {
      sum {
        amount
      }
    }
  }
}
`
const GET_POINTS_USER = `
query BeepointUser(
  $uid: String!, 
  $type: Int,
  $grade_id: Int,
  $subject_id: Int,
  $date_from: timestamptz,
  $date_to: timestamptz,
  $offset: Int, 
  $limit: Int) {
  history_point(where: {
    user_id: {_eq: $uid}, 
    type_point: {_eq: $type},
    created_at: {_gte: $date_from, _lte: $date_to},
    grade_id: {_eq: $grade_id},
    subject_id: {_eq: $subject_id}
  }, order_by: {created_at: asc}, offset: $offset, limit: $limit) {
    id
    name
    amount
    created_at
    competition {
      id
      name
    }
    grade {
      id
      name
    }
    subject {
      id
      name
    }
    question_id
    qa_id
    set_id
    product_id
  }
}
`
const GET_BEEPOINT_TOP3 = `
query getBeepointRank {
  v_beepoint(where: {rank: {_lte: "3"}}) {
    id
    avatar
    fullname
    amount_beepoint
    rank
  }
}
`
const GET_BEEPOINT_RANK_USER = `
query getBeepointRankUser($uid: String!) {
  v_beepoint(where: {id: {_eq: $uid}}) {
    id
    avatar
    fullname
    amount_beepoint
    rank
  }
}
`
const GET_USER_SAME_RANK = `
query getUserSameRank($rank_id: Int) {
  v_user_public (order_by: {id: asc}, where: {rank_id: {_eq: $rank_id}}) {
    id
    fullname
    rank_name
  }
}
`
const GET_RANK_USER = `
query getRankUser($amount: Int!) {
  rank(where: {min_point: {_lt: $amount}}, order_by: {id: desc}, limit: 1) {
    id
    name
  }
}
`
const GET_RANK = `
query getRank {
  rank(order_by: {id: asc}) {
    id
    name
    icon
    min_point
  }
}
`
const GET_PC_TO_USER = `
query getPCToUser($user_id: String, $limit: Int, $offset: Int, $orderBy: [v_pc_teacher_order_by!]) {
  v_pc_teacher(where: {user_id: {_eq: $user_id}}, limit: $limit, offset: $offset, order_by: $orderBy) {
    id
    name
    icon
    banner
    user_id
    fullname
    avatar
    subject_id
    subject_name
    count
    created_at
    status
    site_id
  }
}
`
const GET_PC_OF_USER = `
query getPC($where: private_community_bool_exp, $orderBy: [private_community_order_by!]) {
  private_community(where: $where, order_by: $orderBy) {
    id
    name
    description
    site_id
    subject_id
    user_id
    icon
    banner
    classes {
      id
      name
      private
      type_approval
      exercise_ids
    }
  }
}
`

const GET_GRADE_TO_PC = `
query getAllGradeToPC($pc_id: Int) {
  classes(where: {pc_id: {_eq: $pc_id}}, distinct_on: grade_id) {
    grade {
      id
      name
    }
  }
}
`

const GET_PRIVATE_COMMUNITY = `
query getPrivateCommunity($user_id: String!) {
  private_community(where: {user_id: {_eq: $user_id}}) {
    id
    banner
    name
    pc_users(where: {is_delete: {_eq: false}}) {
      created_at
      is_delete
      updated_at
    }
    subject {
      name
    }
    user {
      avatar
      fullname
    }
  }
}
`

const GET_PRIVATE_COMMUNITY_ALL = `
query getPrivateCommunityAll {
  private_community(limit: 10, order_by: {pc_users_aggregate: {count: desc}}) {
    banner
    icon
    name
    subject {
      name
    }
    pc_users {
      pc_id
    }
    user {
      avatar
      fullname
    }
  }
}
`
const GET_CLASS_IN_PC = `
query getClassInPC($grade_id: bigint!, $user_id: String!, $subject_id: bigint!) {
  classes(where: {grade_id: {_eq: $grade_id}, private_community: {user_id: {_eq: $user_id}, subject_id: {_eq: $subject_id}}}) {
    name
    id
  }
}
`
const GET_NOTIFY_USER = `
query getNotify(
  $uid: String,
  $status: Int, 
  $offset: Int, 
  $limit: Int) {
    user_notification(where: {
    user_id: {_eq: $uid},
    status: {_eq: $status}
  }, order_by: {created_at: desc}, offset: $offset, limit: $limit) {
    id
    title
    short_content
    full_content 
    created_at
    status
    icon
    image
    action_type
    action_url
    message_type
    notification_id
    user {
      avatar
      fullname
    }
  }
}
`
const GET_RELATION_USER = `
query getRelation(
  $uid: String,
  $status: Int!) {
  relation_aggregate(where: {
    user_id_request: {_eq: $uid},  
    status: {_eq: $status}
  }) {
    aggregate {
      count
    }
  },
  alias_aggregate: relation_aggregate(where: {
    user_id_requested: {_eq: $uid},  
    status: {_eq: $status}
  }) {
    aggregate {
      count
    }
  }
}
`
const GET_RELATIONS_FILTER = `
query getRelationFilter(
  $id: uuid,
  $status: Int, 
  $type: Int, 
  $offset: Int, 
  $limit: Int,
  $uid_requested: String,
  $uid: String) {
  relation(
    offset: $offset, 
    limit: $limit, 
    order_by: {created_at: desc}, 
    where: {
      id: {_eq: $id},
      status: {_eq: $status}, 
      type: {_eq: $type}, 
      user_id_request: {_eq: $uid}
    }) {
    id
    userRequest {
      id
      fullname
      avatar
      type_user
    }
    userRequested {
      id
      fullname
      avatar
      type_user
    }
    user_id_request
    user_id_requested
    description
    status
    type
    updated_at
    created_at
  },
  alias: relation(
    offset: $offset, 
    limit: $limit, 
    order_by: {created_at: desc}, 
    where: {
      id: {_eq: $id},
      status: {_eq: $status, _neq: 3}, 
      type: {_eq: $type}, 
      user_id_requested: {_eq: $uid}
    }) {
    id
    userRequest {
      id
      fullname
      avatar
      type_user
    }
    userRequested {
      id
      fullname
      avatar
      type_user
    }
    user_id_request
    user_id_requested
    description
    status
    type
    updated_at
    created_at
  }
}
`
const GET_RELATIONS_FILTER_CONDITION = `
query getRelationFilter(
  $id: uuid,
  $status: Int, 
  $type: Int, 
  $offset: Int, 
  $limit: Int,
  $uid_requested: String,
  $uid: String) {
  relation(
    offset: $offset, 
    limit: $limit, 
    order_by: {created_at: desc}, 
    where: {
      id: {_eq: $id},
      status: {_eq: $status}, 
      type: {_eq: $type}, 
      user_id_request: {_eq: $uid}
    }) {
    id
    userRequest {
      id
      fullname
      avatar
      type_user
    }
    userRequested {
      id
      fullname
      avatar
      type_user
    }
    user_id_request
    user_id_requested
    description
    status
    type
    updated_at
    created_at
  },
  alias: relation(
    offset: $offset, 
    limit: $limit, 
    order_by: {created_at: desc}, 
    where: {
      id: {_eq: $id},
      status: {_eq: $status, _neq: 3}, 
      type: {_eq: $type}, 
      user_id_requested: {_eq: $uid_requested}
    }) {
    id
    userRequest {
      id
      fullname
      avatar
      type_user
    }
    userRequested {
      id
      fullname
      avatar
      type_user
    }
    user_id_request
    user_id_requested
    description
    status
    type
    updated_at
    created_at
  }
}
`
function GET_CATEGORY_FILTER(filtered, offset, limit) {
  return `
  query getcatefilter{
    category(limit: ${limit}, offset: ${offset}, order_by: {updated_at: desc}, where: ${filtered}) {
      id
      name
      created_at
      updated_at
      created_user {
        fullname
      }
      updated_user {
        fullname
      }
      lessons_cate_aggregate(where: {type_lesson: {_eq: 1}, is_delete: {_eq: false}}) {
        aggregate {
          count(columns: category_id)
        }
      }
      video_cate_aggregate(where: {type_lesson: {_eq: 2}, is_delete: {_eq: false}}) {
        aggregate {
          count(columns: category_id)
        }
      }
    }
  }`
}
function GET_CATEGORY_QUESTION_FILTER(filtered, offset, limit) {
  return `
  query getcatequestionfilter{
    category_question(limit: ${limit}, offset: ${offset}, order_by: {updated_at: desc}, where: ${filtered}) {
      id
      name
      created_at
      updated_at  
      created_user {
        fullname
      }
      updated_user {
        fullname
      }
    }
  }`
}
function GET_CATEGORY_EXERCISE_FILTER(filtered, orderBy, offset, limit) {
  return `
  query getcateexercisefilter{
    category_exercise(limit: ${limit}, offset: ${offset}, order_by: ${orderBy}, where: ${filtered}) {
      id
      name
      created_at
      updated_at  
      created_user {
        fullname
      }
      updated_user {
        fullname
      }
    }
  }`
}
const CHECK_EXERCISE_USER_EXIST = `
query checkExericiseUserExist($exercise_id: Int!, $user_id: String!) {
  exercise_user(where: {exercise_id: {_eq: $exercise_id}, user_id: {_eq: $user_id}}) {
    is_delete
  }
}
`
const CHECK_EXERCISE_USER_EXIST2 = `
query checkExericiseUserExist2($where: exercise_user_bool_exp) {
  exercise_user(where: $where) {
    is_delete
  }
}
`
const GET_USER_LINK = `
query getUserLink($keyword: String, $offset: Int, $limit: Int, $uid: String) {
  v_user_public(where: {fullname: {_ilike: $keyword}, is_activated: {_eq: true}, id: {_neq: $uid}}, offset: $offset, limit: $limit) {
    id
    avatar
    fullname
    UserRequested {
      status
      type
      user_id_request
      user_id_requested
    }
  },
  alias: v_user_public(where: {fullname: {_ilike: $keyword}, is_activated: {_eq: true}, id: {_neq: $uid}}, offset: $offset, limit: $limit) {
    id
    avatar
    fullname
    UserRequest {
      status
      type
      user_id_request
      user_id_requested
    }
  }
}
`
const CHECK_LINK_USER = `
query checkLinkUser($uid: String, $uid_requested: String, $type: Int) {
  relation(where: {user_id_request: {_eq: $uid}, user_id_requested: {_eq: $uid_requested}, status: {_eq: 2}, type: {_eq: $type}}) {
    user_id_request
    user_id_requested
    status
    type
  }
  alias: relation(where: {user_id_requested: {_eq: $uid}, user_id_request: {_eq: $uid_requested}, status: {_eq: 2}, type: {_eq: $type}}) {
    user_id_request
    user_id_requested
    status
    type
  }
}
`
const CHECK_SENT_REQUEST_EXIST = `
query checkLinkUser($uid: String, $uid_requested: String, $type: Int) {
  relation(where: {user_id_request: {_eq: $uid}, user_id_requested: {_eq: $uid_requested}, status: {_eq: 1}, type: {_eq: $type}}) {
    user_id_request
    user_id_requested
    status
    type
  }
}
`
const GET_CLASSES_OF_PC = `
query getClassesOfPC($where: classes_bool_exp) {
  classes(where: $where, order_by: {created_at: desc}) {
    id
    name
    pc_id
    type_approval
    private
    grade {
      id
      name
    }
    private_community {
      id
      name
      site_id
    }
    exercise_ids
  }
}
`

const GET_CLASSES_TO_PC = `
query getAllClass($id: Int, $name: String, $grade_id: bigint, $pc_id: Int, $limit: Int, $offset: Int, $order_by: [classes_order_by!]) {
  classes(where: {id: {_eq: $id}, name: {_ilike: $name}, grade_id: {_eq: $grade_id}, is_delete: {_eq: false}, pc_id: {_eq: $pc_id}}, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    thumbnail
    name
    description
    pc_id
    type_approval
    private
    updated_at
    lstChannel_aggregate(where: {is_delete: {_eq: false}}) {
      aggregate {
        count
      }
    }
    grade {
      name
    }
    private_community {
      id
      name
      pc_users_aggregate {
        aggregate {
          count
        }
      }
    }
    grade_id
    exercise_ids
  }
}
`
const GET_USER_JOIN_PC = `
query getUserJoinPC($pc_id: Int, $user_id: String, $classes_id: Int, $position: Int, $fullname: String, $grade_id: bigint, $status: Int, $limit: Int, $order_by: [pc_user_order_by!]) {
  pc_user(where: {pc_id: {_eq: $pc_id}, user_id: {_eq: $user_id}classes_id: {_eq: $classes_id}, position: {_eq: $position}, user: {fullname: {_ilike: $fullname}}, classes: {grade_id: {_eq: $grade_id}}, status: {_eq: $status}, is_delete: {_eq: false}}, limit: $limit, order_by: $order_by) {
    pc_id
    user_id
    classes_id
    status
    position
    user {
      avatar
      fullname
      type_user
    }
    classes {
      id
      name
      grade {
        name
        id
      }
      exercise_ids
    }
  }
}
`

const GET_USER_JOIN_PC_COUNT_STATUS = `
query getCountUserJoinPC($pc_id: Int, $classes_id: Int, $status: Int) {
  pc_user_aggregate(where: {classes_id: {_eq: $classes_id}, status: {_eq: $status}, is_delete: {_eq: false}, pc_id: {_eq: $pc_id}}) {
    aggregate {
      count
    }
  }
}
`

const CHECK_USER_JOIN_PC = `
query checkUserJoinPC($pc_id: Int!, $classes_id: Int!, $user_id: String!) {
  pc_user(where: {pc_id: {_eq: $pc_id}, classes_id: {_eq: $classes_id}, user_id: {_eq: $user_id}}) {
    is_delete
  }
}
`
const GET_USER_JOIN_PC_MEMBER = `
query getUserJoinPCMember($user_id: String, $order_by: [private_community_order_by!]) {
  private_community(where: {user_id: {_eq: $user_id}}, order_by: $order_by) {
    id
    name
    icon
    classes {
      id
      name
      private
      type_approval
      exercise_ids
    }
  }
}
`
const GET_RELATION_OF_USER = `
query getRelationOfUser($user_id: String, $fullname: String, $email: String, $type: [Int!], $status: Int) {
  relation(where: {_or: [{user_id_request: {_eq: $user_id}}, {user_id_requested: {_eq: $user_id}}], _and: {userRequest: {_or: [{fullname: {_ilike: $fullname}}, {email: {_ilike: $email}}]}, userRequested: {_or: [{fullname: {_ilike: $fullname}}, {email: {_ilike: $email}}]}}, type: {_in: $type}, status: {_eq: $status}}) {
    user_id_request
    user_id_requested
    id
    status
    type
    userRequest {
      id
      fullname
      avatar
      email
    }
    userRequested {
      id
      fullname
      avatar
      email
    }
  }
}
`
const GET_USER_JOIN_FIRST_LAST = `
query getUserJoinFirstLast($user_id: String, $order_by: [pc_user_order_by!]) {
  pc_user(order_by: $order_by, limit: 1, where: {user_id: {_eq: $user_id}}) {
    pc_id
    classes_id
    created_at
    date_approval
    user_approval
    updated_at
    updated_by
    user {
      avatar
      fullname
      id
    }
    userApproval {
      avatar
      fullname
      id
    }
    userUpdated {
      avatar
      fullname
      id
    }
  }
}
`
const GET_USER_PC_GROUP_STATUS = `
query GET_USER_PC_GROUP_STATUS($where: private_community_bool_exp, $wherePCUser: pc_user_bool_exp) {
  private_community(where: $where) {
    id
    name
    pc_users(where: $wherePCUser, distinct_on: pc_id) {
      pc_id
      user_approval
    }
  }
}
`
const GET_COUNT_HISTORY_USER_ACTION_PC = `
query getCountHistoryUserActionPC($where: pc_history_bool_exp) {
  pc_history_aggregate(where: $where, distinct_on: user_id) {
    aggregate {
      count
    }
    nodes {
      pc_id
      user_id
      action
      description
      created_at
      access_time
    }
  }
}
`
const GET_PC_USER_JOIN_STUDENT = `
query getPCUserJoinStudent($where: pc_user_bool_exp, $order_by: [pc_user_order_by!]) {
  pc_user(where: $where, order_by: $order_by) {
    pc_id
    user_id
    un_pin
    status
    position
    created_at
    updated_at
    private_community {
      id
      name
      icon
    }
  }
}
`
const GET_COUNT_CATEGORY_QUESTION_USED = `
query getCountCategoryQuestionUsed($where: question_bool_exp) {
  question_aggregate(where: $where) {
    aggregate {
      count
    }
    nodes {
      id
      content
    }
  }
}
`
const GET_COUNT_CATEGORY_EXERCISE_USED = `
query getCountCategoryExerciseUsed($where: exercise_bool_exp) {
  exercise_aggregate(where: $where) {
    aggregate {
      count
    }
    nodes {
      id
      name
    }
  }
}
`
const GET_COUNT_CATEGORY_LESSON_USED = `
query getCountCategoryLessonUsed($where: lesson_bool_exp) {
  lesson_aggregate(where: $where) {
    aggregate {
      count
    }
    nodes {
      id
      name
    }
  }
}
`
const GET_COUNT_LESSON_USED = `
query getCountLessonUsed($where: lesson_question_bool_exp) {
  lesson_question_aggregate(where: $where) {
    aggregate {
      count
    }
    nodes {
      lesson_id
    }
  }
}
`
const GET_COUNT_QUESTION_USED = `
query getCountQuestionUsed($where: result_details_bool_exp) {
  result_details_aggregate(where: $where) {
    aggregate {
      count
    }
    nodes {
      id
      question_id
    }
  }
}
`
const GET_COUNT_EXERCISE_USED = `
query getCountExerciseUsed($where: result_bool_exp) {
  result_aggregate(where: $where) {
    aggregate {
      count
    }
    nodes {
      id
      exercise_id
    }
  }
}
`
const GET_EXERCISES = `
query getExercise($where: exercise_bool_exp, $order_by: [exercise_order_by!], $offset: Int, $limit: Int) {
  exercise(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
    id
    name
    level
    categ_id
    subject_id
    type_test
    time
    is_public
    is_public_pc
    created_at
    updated_at
    amount_honey
    is_lock
    is_complete
    userCreate {
      fullname
    }
    userUpdate {
      fullname
    }
    category_exercise {
      id
      name
    }
    exercise_grades {
      grade {
        id
        name
      }
    }
    question_exercises {
      question {
        id
        content
        content_plain_text
        level
        subject_id
        categ_id
        time
        amount_honey
        category_question {
          id
          name
        }
        question_grade {
          grade {
            id 
            name
          }
        }
      }
    }
  }
}
`

const GET_CLASS_USER_JOIN_STUDENT = `
query getClassUserJoinStudent($where: pc_user_bool_exp, $order_by: [pc_user_order_by!]) {
  pc_user(where: $where, order_by: $order_by) {
    pc_id
    user_id
    classes_id
    un_pin_class
    status
    created_at
    updated_at
    classes {
      id
      name
      thumbnail
      private
      grade_id
      exercise_ids
    }
  }
}
`
const GET_FIRST_QUESTION = `
query getFirstQuestion($where: question_bool_exp) {
  question(where: $where) {
    id
    categ_id
    level
    subject_id
    time
    amount_honey
    is_type_question
    content
    link_audio
    is_complete
    userCreate {
      fullname
    }
    userUpdate {
      fullname
    }
    created_at
    updated_at
    question_grade {
      grade {
        id
        name
      }
    }
    question_details(order_by: {id: asc}, where: {is_delete: {_eq: false}}) {
      id
      type
      is_shuffle
      content
      explain
      point
      sub_point
      lesson_questions {
        lesson {
          id
          name
          content
        }
      }
      answers(order_by: {id: asc}, where: {is_delete: {_eq: false}}) {
        id
        value
        content
        is_correct
      }
    }
  }
}
`
const GET_QUESTION = `
query getQuestion(
  $uid: String,
  $name: String, 
  $limit: Int, $offset: Int, 
  $is_complete: Boolean, 
  $subject_id: Int,
  $levels: [Int!],
  $categ_ids: [Int!],
  $grade_ids: [Int!],
  $order_by: [question_order_by!]) {
  question(where: {
    created_by: {_eq: $uid}, 
    is_delete: {_eq: false}, 
    is_complete: {_eq: $is_complete},
    subject_id: {_eq: $subject_id},
    level: {_in: $levels},
    categ_id: {_in: $categ_ids},
    question_grade: {grade_id: {_in: $grade_ids}}
    content_plain_text: {_ilike: $name}
  }, limit: $limit, offset: $offset, order_by: $order_by) {
    id
    content
    content_plain_text
    is_lock
    is_type_question
    time
    level
    link_audio
    amount_honey
    subject_id
    categ_id
    category_question {
      id
      name
    }
    question_grade {
      grade {
        id
        name
      }
    }
    is_complete
    updated_at
    created_at
    userCreate {
      fullname
    }
    userUpdate {
      fullname
    }
  }
}
`
const GET_CLASSES_WITH_SUBJECT = `
query getClassWithSubject($user_id: String, $subject_id: bigint, $order_by: [classes_order_by!]) {
  classes(where: {
    private_community: {user_id: {_eq: $user_id}, subject_id: {_eq: $subject_id}}
  }, order_by: $order_by) {
    name
    id
    exercise_ids
  }
}
`
const GET_RESULTS = `
query getResults($where: result_bool_exp, $order_by: [result_order_by!], $offset: Int, $limit: Int) {
  result(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
    id
    name
    user_id
    total_score
    total_time
    exercise_id
    status
    buy_explain
    updated_at
    class_id
    class {
      name
      pc_id
      private_community {
        name
        icon
      }
    }
    exercise {
      userCreate {
        fullname
        avatar
      }
      subject {
        name
      }
      exercise_grades {
        grade {
          id
          name
        }
      }
    }
  }
}
`
const GET_CHANNEL = `
query getChanelList($where: channel_bool_exp, $order_by: [channel_order_by!], $limit: Int) {
  channel(where: $where, order_by: $order_by, limit: $limit) {
    id
    name
    private
    created_at
    updated_at
    created_by
    updated_by
    class {
      id
      name
      pc_id
      grade_id
    }
  }
}
`
const GET_CLASSES_GRADE_PC = `
query getClassGradePC($where: classes_bool_exp) {
  classes(where: $where) {
    id
    name
    thumbnail
    private
    type_approval
    private_community {
      id
      name
      icon
      status
    }
    grade {
      id
      name
      type_grade
    }
  }
}
`
const GET_LESSON_PLANING_CLASSES_OF_PC = `
query getAllLessonClassesOfPC($where: lesson_class_bool_exp, $offset: Int, $limit: Int, $orderBy: [lesson_class_order_by!]) {
  lesson_class(where: $where, limit: $limit, offset: $offset, order_by: $orderBy) {
    class {
      id
      name
      pc_id
      thumbnail
      type_approval
    }
    lesson_id
    class_id
    start_date
    created_at
    lesson {
      id
      name
      link_video
      thumbnail
      type_lesson
      banner
      category_id
      category {
        name
        id
      }
    }
  }
}
`
const GET_CATEGORIES_OF_USER = `
query getAllCategoriesOfUser($where: category_bool_exp, $orderBy: [category_order_by!]) {
  category(where: $where, order_by: $orderBy) {
    id
    name
    note
    created_at
    created_by
  }
}
`
const GET_GRADES_OF_USER = `
query getAllGradeOfUserLesson($where: lesson_bool_exp, $orderBy: [lesson_order_by!]) {
  lesson(where: $where, order_by: $orderBy) {
    id
    name
    banner
    thumbnail
    category_id
    grade_id
    grade {
      id
      name
    }
    category {
      id
      name
    }
  }
}
`
const CHECK_LESSON_CLASS = `
query getLessonClass($where: lesson_class_bool_exp) {
  lesson_class(where: $where) {
    lesson_id
    class_id
    start_date
  }
}
`
const GET_LESSON_PLANING_EXERCISE_CLASSES_OF_PC = `
query getAllExerciseClassesOfPC($where: exercise_class_bool_exp, $offset: Int, $limit: Int, $orderBy: [exercise_class_order_by!]) {
  exercise_class(where: $where, limit: $limit, offset: $offset, order_by: $orderBy) {
    class {
      id
      name
      pc_id
      thumbnail
      type_approval
    }
    exercise_id
    class_id
    start_date
    created_at
    exercise {
      id
      name
      name_en
      level
      categ_id
      category_exercise {
        id
        name
      }
    }
  }
}
`
const GET_CATEGORIES_EXERCISE_OF_USER = `
query getAllCategoriesExerciseOfUser($where: category_exercise_bool_exp, $orderBy: [category_exercise_order_by!]) {
  category_exercise(where: $where, order_by: $orderBy) {
    id
    name
    created_at
    created_by
  }
}
`
const GET_GRADES_EXERCISE_OF_USER = `
query getAllGradeExerciseOfUser($where: exercise_bool_exp, $orderBy: [exercise_order_by!]) {
  exercise(where: $where, order_by: $orderBy) {
    id
    name
    name_en
    level
    categ_id
    category_exercise {
      id
      name
    }
    exercise_grades {
      grade_id
      grade {
        id
        name
      }
    }
  }
}
`
const GET_COUNT_LESSON_CLASS_IN_PC = `
query getCountLessonClassInPC($where: lesson_class_bool_exp) {
  lesson_class_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`
const GET_COUNT_LESSON_CLASS_DISTINCT_IN_PC = `
query getCountLessonClassInPC($where: lesson_class_bool_exp) {
  lesson_class_aggregate(where: $where) {
    aggregate {
      count(columns: lesson_id, distinct: true)
    }
  }
}
`

const GET_COUNT_EXERCISE_IN_PC = `
query getCountLessonExerciseInPC($where: exercise_class_bool_exp) {
  exercise_class_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
`
const GET_COUNT_EXERCISE_DISTINCT_IN_PC = `
query getCountLessonExerciseInPC($where: exercise_class_bool_exp) {
  exercise_class_aggregate(where: $where) {
    aggregate {
      count(columns: exercise_id, distinct: true)
    }
  }
}
`

const CHECK_EXERCISE_CLASS = `
query getExerciseClass($where: exercise_class_bool_exp) {
  exercise_class(where: $where) {
    class_id
    exercise_id
    start_date
  }
}
`
const GET_CLASSES_ME_LESSON = `
query getLessonsClassMe($wherePC: private_community_bool_exp, $where: v_front_lesson_class_me_bool_exp, $order_by: [v_front_lesson_class_me_order_by!], $offset: Int, $limit: Int) {
  private_community(where: $wherePC) {
    v_front_lesson_class_me(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      name
      read
      type_lesson
      subject_name
      subject_id
      grade_name
      grade_id
      fullname
      count_share
      count_like
      count_comment
      banner
      avatar
      updated_at
      content
      files
      link_video
      thumbnail
      teacher_id
      start_date
      class_id
    }
  }
}
`
const GET_CLASSES_ME_EXERCISE = `
query getExerciseClassMe($where: v_front_exercise_class_me_bool_exp, $offset: Int, $limit: Int, $order_by: [v_front_exercise_class_me_order_by!]){
  v_front_exercise_class_me(where:$where, offset: $offset, limit: $limit, order_by: $order_by) {
    id
    name
    name_en
    status
    type_test
    level
    time
    updated_at
    grade_name
    grade_id
    count_share
    count_like
    count_comment
    amount_honey
    is_public
    class_id
    start_date
  }
}
`
const GET_PRIVATE_COMMUNITY_USER_ALL = `
query getPrivateCommunityForUser($where: private_community_bool_exp!, $orderBy: [private_community_order_by!], $limit: Int) {
  private_community(where: $where, order_by: $orderBy, limit: $limit) {
    id
    banner
    icon
    name
    subject {
      name
    }
    pc_users {
      pc_id
    }
    user {
      avatar
      fullname
    }
  }
}
`

// ======================== INSERT ======================== //
const CREATE_USER = `
mutation create_user($users: [users_insert_input!]! ) {
  insert_users(objects: $users) {
    affected_rows
    returning {
      id
      fullname
    }
  }
}`

const CREATE_USER_SUBJECT = `
mutation create_user_subject($subjects: [subject_user_insert_input!]! ) {
  insert_subject_user(objects: $subjects) {
    affected_rows
  }
}
`
const CREATE_USER_GRADE = `
mutation create_user_grade($grades: [grade_user_insert_input!]! ) {
  insert_grade_user(objects: $grades) {
    affected_rows
  }
}
`
const CREATE_SUBJECT = `mutation create_subject($name: String!, $description: String, $icon: String) {
  insert_subjects(objects: {name: $name, description: $description, icon: $icon}) {
    affected_rows
    returning {
      id
      name
      description
      icon
    }
  }
}`
const CREATE_CATEGORY = `mutation create_category($name: String!, $created_by: String!) {
  insert_category(objects: {name: $name, created_by: $created_by, updated_by: $created_by}) {
    affected_rows
    returning {
      id
      name
      created_at
      updated_at
      created_user {
        fullname
      }
      updated_user {
        fullname
      }
      lessons_cate_aggregate(where: {type_lesson: {_eq: 1}, is_delete: {_eq: false}}) {
        aggregate {
          count(columns: category_id)
        }
      }
      video_cate_aggregate(where: {type_lesson: {_eq: 2}, is_delete: {_eq: false}}) {
        aggregate {
          count(columns: category_id)
        }
      }
    }
  }
}`
const CREATE_CATEGORY_QUESTION = `
mutation create_category_question($name: String, $created_by: String) {
  insert_category_question(objects: {name: $name, created_by: $created_by, updated_by: $created_by}) {
    affected_rows
    returning {
      id
      name
      created_at
      updated_at
      created_user {
        fullname
      }
      updated_user {
        fullname
      }
    }
  }
}
`
const CREATE_CATEGORY_EXERCISE = `
mutation create_category_exercise($name: String, $created_by: String) {
  insert_category_exercise(objects: {name: $name, created_by: $created_by, updated_by: $created_by}) {
    affected_rows
    returning {
      id
      name
      created_at
      updated_at
      created_user {
        fullname
      }
      updated_user {
        fullname
      }
    }
  }
}
`
const CREATE_GRADES = `mutation create_grades($name: String!, $description: String, $type_grade: Int!) {
  insert_grades(objects: {name: $name, description: $description, type_grade: $type_grade }) {
    affected_rows
    returning {
      id
      name
      description
      type_grade
    }
  }
}
`
const CREATE_ACHIEVES = `mutation create_achievement($name: String!, $icon: String) {
  insert_achievement(objects: {icon: $icon, name: $name}) {
    affected_rows
    returning {
      id
      name
      icon
      created_at
      updated_at
    }
  }
}`

const CREATE_LESSON = `
mutation create_lesson($lesson: [lesson_insert_input!]! ) {
  insert_lesson(objects: $lesson) {
    affected_rows
    returning {
      id
    }
  }
}
`
const CREATE_RELATION = `
mutation create_relation($object: [relation_insert_input!]! ) {
  insert_relation(objects: $object) {
    affected_rows
  }
}
`
const CREATE_PC = `
mutation create_pc($name: String, $user_id: String, $description: String, $subject_id: bigint, $site_id: String) {
  insert_private_community(objects: {name: $name, user_id: $user_id, description: $description, subject_id: $subject_id, site_id: $site_id}) {
    returning {
      id
      user_id
    }
    affected_rows
  }
}`

const CREATE_CLASSES = `
mutation createClasses($name: String, $grade_id: bigint, $pc_id: Int, $private: Boolean, $type_approval: Int, $created_by: String) {
  insert_classes(objects: {name: $name, grade_id: $grade_id, pc_id: $pc_id, private: $private, type_approval: $type_approval, created_by: $created_by}) {
    affected_rows
    returning {
      id
    }
  }
}
`
const CREATE_QUESTION = `
mutation create_question($question: [question_insert_input!]! ) {
  insert_question(objects: $question) {
    affected_rows
    returning {
      id
    }
  }
}
`
const CREATE_QUESTION_DETAILS = `
mutation create_question_details($question_details: [question_details_insert_input!]! ) {
  insert_question_details(objects: $question_details) {
    affected_rows
    returning {
      id
    }
  }
}
`
const CREATE_ANSWER = `
mutation create_answer($answers: [answer_insert_input!]! ) {
  insert_answer(objects: $answers) {
    affected_rows
    returning {
      id
    }
  }
}
`
const CREATE_LESSON_QUESTION = `
mutation create_lesson_question($object: [lesson_question_insert_input!]! ) {
  insert_lesson_question(objects: $object) {
    affected_rows
  }
}
`
const CREATE_QUESTION_GRADE = `
mutation create_question_grade($object: [question_grade_insert_input!]! ) {
  insert_question_grade(objects: $object) {
    affected_rows
  }
}
`
const CREATE_EXERCISE = `
mutation create_exercise($exercise: [exercise_insert_input!]! ) {
  insert_exercise(objects: $exercise) {
    affected_rows
    returning {
      id
    }
  }
}
`
const CREATE_QUESTION_EXERCISE = `
mutation create_question_exercise($object: [question_exercise_insert_input!]! ) {
  insert_question_exercise(objects: $object) {
    affected_rows
  }
}
`
const CREATE_EXERCISE_USER = `
mutation create_exercise_user($object: [exercise_user_insert_input!]! ) {
  insert_exercise_user(objects: $object) {
    affected_rows
  }
}
`
const CREATE_EXERCISE_GRADE = `
mutation create_exercise_grade($object: [exercise_grade_insert_input!]! ) {
  insert_exercise_grade(objects: $object) {
    affected_rows
  }
}
`
const CREATE_USER_JOIN_TO_PC = `
mutation create_pc_user($pc_id: Int, $user_id: String, $status: Int, $classes_id: Int, $position: Int) {
  insert_pc_user(objects: {pc_id: $pc_id, user_id: $user_id, status: $status, classes_id: $classes_id, position: $position, is_delete: false}) {
    affected_rows
  }
}
`
const CREATE_PC_HISTORY = `
mutation create_pc_history($objInput: [pc_history_insert_input!]!) {
  insert_pc_history(objects: $objInput) {
    affected_rows
  }
}
`
const CREATE_CHANNEL = `
mutation insert_chanel($objInput: [channel_insert_input!]!) {
  insert_channel(objects: $objInput) {
    affected_rows
  }
}
`
const CREATE_LESSON_CLASSES = `
mutation create_lesson_class($objInput: [lesson_class_insert_input!]!) {
  insert_lesson_class(objects: $objInput) {
    affected_rows
  }
}
`
const CREATE_LESSON_GRADE = `
mutation create_lesson_grade($object: [lesson_grade_insert_input!]! ) {
  insert_lesson_grade(objects: $object) {
    affected_rows
  }
}
`

const CREATE_EXERCISE_CLASSES = `
mutation create_lesson_class($objInput: [exercise_class_insert_input!]!) {
  insert_exercise_class(objects: $objInput) {
    affected_rows
  }
}
`

// ======================== UPDATE ======================== //
const UPDATE_PROFILE = `
mutation updateUser (
    $uid: String!, 
    $fullname: String, 
    $userquotes: String, 
    $phone: String,
    $birthday: date,
    $name_color: String,
    $school_id: Int,
    $grade_id: _text,
    $is_show_email: Boolean,
    $is_show_phone: Boolean,
    $is_show_birthday: Boolean
  ) {
  update_users(where: {id: {_eq: $uid}}, _set: {
    fullname: $fullname,
    userquotes: $userquotes,
    phone_number: $phone,
    school_id: $school_id,
    grade_id: $grade_id,
    name_color: $name_color,
    birthday: $birthday,
    is_show_email: $is_show_email,
    is_show_phone: $is_show_phone,
    is_show_birthday: $is_show_birthday
  }) {
    affected_rows
    returning {
      id
      fullname
      email
      cover
      avatar
      rank_id
      type_user
    }
  }
}
`
const UPDATE_USER_VERIFY = `
mutation VerifyUser ($uid: String!) {
  update_users(where: {id: {_eq: $uid}}, _set: {
    is_activated: true
  }) {
    affected_rows
  }
}
`
const UPDATE_AVATAR = `
mutation updateAvatar ($uid: String!, $avatar: String) {
  update_users(where: {id: {_eq: $uid}}, _set: {
    avatar: $avatar
  }) {
    affected_rows
    returning {
      id
      avatar
    }
  }
}
`
const UPDATE_COVER = `
mutation updateCover ($uid: String!, $cover: String) {
  update_users(where: {id: {_eq: $uid}}, _set: {
    cover: $cover
  }) {
    affected_rows
    returning {
      id
      cover
    }
  }
}
`
const UPDATE_SUBJECT = `
mutation editSubjects($id: Int!, $name: String!, $description: String, $icon: String) {
  update_subjects(where: { id: { _eq: $id } }, _set: { description: $description, name: $name, icon: $icon }) {
    affected_rows
  }                                                                                                                                                                                                                                                                                          
}
`
const UPDATE_CATEGORY = `
mutation editCategory($id: Int!, $updated_user: String!, $name: String!) {
  update_category(where: { id: { _eq: $id } }, _set: { updated_by: $updated_user, name: $name }) {
    affected_rows
    returning {
      id
      name
      created_at
      updated_at
      created_user {
        fullname
      }
      updated_user {
        fullname
      }
      lessons_cate_aggregate(where: {type_lesson: {_eq: 1}, is_delete: {_eq: false}}) {
        aggregate {
          count(columns: category_id)
        }
      }
      video_cate_aggregate(where: {type_lesson: {_eq: 2}, is_delete: {_eq: false}}) {
        aggregate {
          count(columns: category_id)
        }
      }
    }
  }                                                                                                                                                                                                                                                                                          
}
`
const UPDATE_GRADES = `
mutation editGrades($id: Int!, $name: String!, $description: String, $type_grade: Int) {
  update_grades(where: { id: { _eq: $id } }, _set: { description: $description, name: $name, type_grade: $type_grade }) {
    affected_rows
  }                                                                                                                                                                                                                                                                                          
}
`
const UPDATE_ACHIEVES = `
mutation editAchieves($id: Int!, $name: String!, $icon: String) {
  update_achievement(where: { id: { _eq: $id } }, _set: { icon: $icon, name: $name}) {
    affected_rows
  }                                                                                                                                                                                                                                                                                          
}
`
const UPDATE_USER_DEGREES = `
mutation updateDegrees ($uid: String, $degrees: _text) {
  update_users(where: {id: {_eq: $uid}}, _set: {
    degrees: $degrees
  }) {
    affected_rows
  }
}
`
const UPDATE_READ_NOTIFY = `
mutation updateNotification($id: uuid, $uid: String, $changes: user_notification_set_input) {
  update_user_notification(
    where: {id: {_eq: $id}, user_id: {_eq: $uid}},
    _set: $changes
  ) {
    affected_rows
    returning {
      id
      title
      short_content
      full_content 
      status
      icon
      image
      action_type
      action_url
      message_type
    }
  }
}
`
const UPDATE_LESSON = `
mutation updatelesson($lesson_id1: bigint!, $lesson_id: Int!, $banner: _text!, $category_id: bigint!, $files: _text!, $grade_id: bigint!, $is_public: Int!, $name: String!, $content: String!, $subject_id: bigint!, $updated_by: String!, $insert_class: [lesson_class_insert_input!]!) {
  update_lesson(where: {id: {_eq: $lesson_id}}, _set: {banner: $banner, category_id: $category_id, content: $content, files: $files, grade_id: $grade_id, is_public: $is_public, name: $name, subject_id: $subject_id, updated_by: $updated_by}) {
    affected_rows
  }
  delete_lesson_class(where: {lesson_id: {_eq: $lesson_id1}}) {
    affected_rows
  }
  insert_lesson_class(objects: $insert_class) {
    affected_rows
  }
}
`
const UPDATE_LESSON2 = `
mutation updateLesson($where: lesson_bool_exp!, $changes: lesson_set_input) {
  update_lesson(where: $where, _set: $changes) {
    affected_rows
    returning {
      id
    }
  }
}
`
const UPDATE_LESSON_VIDEO = `
mutation updatelessonvideo($lesson_id1: bigint!, $lesson_id: Int!, $link_video: String!, $thumbnail: String!, $category_id: bigint!, $files: _text!, $grade_id: bigint!, $is_public: Int!, $name: String!, $content: String!, $subject_id: bigint!, $updated_by: String!, $insert_class: [lesson_class_insert_input!]!) {
  update_lesson(where: {id: {_eq: $lesson_id}}, _set: {thumbnail: $thumbnail, link_video: $link_video, category_id: $category_id, content: $content, files: $files, grade_id: $grade_id, is_public: $is_public, name: $name, subject_id: $subject_id, updated_by: $updated_by}) {
    affected_rows
  }
  delete_lesson_class(where: {lesson_id: {_eq: $lesson_id1}}) {
    affected_rows
  }
  insert_lesson_class(objects: $insert_class) {
    affected_rows
  }
}
`
const UPDATE_RELATION_USER = `
mutation updateRelation($id: uuid, $status: Int) {
  update_relation(where: { id: { _eq: $id } }, _set: { status: $status}) {
    affected_rows
  }                                                                                                                                                                                                                                                                                          
}
`
const UPDATE_PC_IMG = `
mutation update_pc_img($id: Int, $user_id: String, $banner: _text, $icon: String) {
  update_private_community(where: {id: {_eq: $id}, user_id: {_eq: $user_id}}, _set: {banner: $banner, icon: $icon}) {
    returning {
      id
      user_id
    }
    affected_rows
  }
}
`
const UPDATE_PC = `
mutation update_pc($id: Int, $user_id: String, $name: String, $description: String, $subject_id: bigint) {
  update_private_community(where: {id: {_eq: $id}, user_id: {_eq: $user_id}}, _set: {name: $name, description: $description, subject_id: $subject_id}) {
    returning {
      id
      user_id
    }
    affected_rows
  }
}
`
const UPDATE_CLASSES = `
mutation updateClasses($pc_id: Int, $id: Int, $updated_by: String, $name: String, $grade_id: bigint, $private: Boolean, $type_approval: Int) {
  update_classes(where: {pc_id: {_eq: $pc_id}, id: {_eq: $id}}, _set: {updated_by: $updated_by, name: $name, grade_id: $grade_id, private: $private, type_approval: $type_approval}) {
    affected_rows
    returning {
      id
    }
  }
}
`
const UPDATE_CLASSES2 = `
mutation updateClasses($where: classes_bool_exp!, $changes: classes_set_input) {
  update_classes(where: $where, _set: $changes) {
    affected_rows
    returning {
      id
    }
  }
}
`
const UPDATE_CLASSES_APPROVAL = `
mutation updateClasses($pc_id: Int!, $id: Int!, $updated_by: String!, $type_approval: Int) {
  update_classes(where: {pc_id: {_eq: $pc_id}, id: {_eq: $id}}, _set: {updated_by: $updated_by, type_approval: $type_approval}) {
    affected_rows
    returning {
      id
    }
  }
}
`

const UPDATE_CLASSES_IMG = `
mutation updateClassesThumbnail($thumbnail: String, $pc_id: Int, $id: Int) {
  update_classes(where: {pc_id: {_eq: $pc_id}, id: {_eq: $id}}, _set: {thumbnail: $thumbnail}) {
    affected_rows
  }
}
`
const UPDATE_CATEGORY_QUESTION = `
mutation updateCategoryQuestion($id: Int, $is_delete: Boolean, $name: String) {
  update_category_question(where: { id: { _eq: $id } }, _set: { is_delete: $is_delete, name: $name }) {
    affected_rows
    returning {
      id
      name
      is_delete
      updated_at
      updated_user {
        fullname
      }
    }
  }
}
`
const UPDATE_CATEGORY_EXERCISE = `
mutation updateCategoryExercise($id: Int, $is_delete: Boolean, $name: String) {
  update_category_exercise(where: { id: { _eq: $id } }, _set: { is_delete: $is_delete, name: $name }) {
    affected_rows
    returning {
      id
      name
      is_delete
      updated_at
      updated_user {
        fullname
      }
    }
  }
}
`
const UPDATE_QUESTION_AUDIO = `
mutation update_question_audio($id: Int, $link_audio: String) {
  update_question(where: {id: {_eq: $id}}, _set: {link_audio: $link_audio}) {
    affected_rows
    returning {
      id
    }
  }
}
`
const UPDATE_QUESTION = `
mutation updateQuestion($question_id: Int!, $changes: question_set_input) {
  update_question(where: {id: {_eq: $question_id}}, _set: $changes) {
    affected_rows
    returning {
      id
    }
  }
}
`
const UPDATE_QUESTION_DETAILS = `
mutation updateQuestionDetails($id: Int!, $changes: question_details_set_input) {
  update_question_details(where: {id: {_eq: $id}}, _set: $changes) {
    affected_rows
    returning {
      id
    }
  }
}
`
const UPDATE_ANSWER = `
mutation updateAnswer($id: Int!, $changes: answer_set_input) {
  update_answer(where: {id: {_eq: $id}}, _set: $changes) {
    affected_rows
    returning {
      id
    }
  }
}
`
const UPDATE_PC_USER_ALL = `
mutation updatePCUserAll($objWhere: pc_user_bool_exp!, $objInput: pc_user_set_input) {
  update_pc_user(where: $objWhere, _set: $objInput) {
    affected_rows
  }
}
`
const UPDATE_CHANNEL = `
mutation update_channel($objInput: channel_set_input, $objWhere: channel_bool_exp!) {
  update_channel(_set: $objInput, where: $objWhere) {
    affected_rows
  }
}
`
const UPDATE_EXERCISE_USER = `
mutation updateExerciseUser($objWhere: exercise_user_bool_exp!, $objInput: exercise_user_set_input) {
  update_exercise_user(where: $objWhere, _set: $objInput) {
    affected_rows
  }
}
`
const UPDATE_EXERCISE = `
mutation updateExercise($exercise_id: Int!, $changes: exercise_set_input) {
  update_exercise(where: {id: {_eq: $exercise_id}}, _set: $changes) {
    affected_rows
    returning {
      id
    }
  }
}
`
const UPDATE_LESSON_PLANNING = `
mutation update_lesson($objInput: lesson_set_input, $objWhere: lesson_bool_exp!) {
  update_lesson(_set: $objInput, where: $objWhere) {
    affected_rows
  }
}
`

const UPDATE_LESSON_CLASSES = `
mutation update_lesson_class($objWhere: lesson_class_bool_exp!, $objInput: lesson_class_set_input) {
  update_lesson_class(where: $objWhere, _set: $objInput) {
    affected_rows
  }
}
`
const UPDATE_EXERCISE_CLASS = `
mutation updateExerciseClass($objWhere: exercise_class_bool_exp!, $objInput: exercise_class_set_input) {
  update_exercise_class(where: $objWhere, _set: $objInput) {
    affected_rows
  }
}
`
const UPDATE_EXERCISE_PUBLIC = `
mutation updateExercise($objWhere: exercise_bool_exp!, $objInput: exercise_set_input) {
  update_exercise(where: $objWhere, _set: $objInput) {
    affected_rows
  }
}
`

// ======================== DELETE ======================== //
const DELETE_SUBJECT = `
mutation deleteSubjects($id: Int, $is_delete: Boolean!) {
  update_subjects(where: { id: { _eq: $id } }, _set: { is_delete: $is_delete }) {
    affected_rows
  }
}
`
const DELETE_GRADES = `
mutation deleteGrades($id: Int, $is_delete: Boolean!) {
  update_grades(where: { id: { _eq: $id } }, _set: { is_delete: $is_delete }) {
    affected_rows
  }
}
`
const DELETE_ACHIEVES = `
mutation deleteAchieves($id: Int, $is_delete: Boolean!) {
  update_achievement(where: { id: { _eq: $id } }, _set: { is_delete: $is_delete }) {
    affected_rows
  }
}
`

const DELETE_LESSON = `
mutation deleteLessons($id: Int, $is_delete: Boolean!) {
  update_lesson(where: { id: { _eq: $id } }, _set: { is_delete: $is_delete }) {
    affected_rows
  }
}
`
const DELETE_RELATION = `
mutation deleteRelation($id: uuid) {
  delete_relation(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
`
const DELETE_CATEGORY = `
mutation deleteCategory($id: Int, $is_delete: Boolean!) {
  update_category(where: { id: { _eq: $id } }, _set: { is_deleted: $is_delete }) {
    affected_rows
  }
}
`
const DELETE_CLASSES = `
mutation delete_classes($pc_id: Int, $id: Int, $updated_by: String) {
  update_classes(where: {pc_id: {_eq: $pc_id}, id: {_eq: $id}}, _set: {is_delete: true, updated_by: $updated_by}) {
    affected_rows
  }
}
`
const DELETE_LESSON_CLASS = `
mutation deleteLessonClass($objWhere: lesson_class_bool_exp!) {
  delete_lesson_class(where: $objWhere) {
    affected_rows
  }
}
`
const DELETE_QUESTION_GRADE = `
mutation deleteQuestionGrade($grade_id: Int, $question_id: Int) {
  delete_question_grade(where: {grade_id: {_eq: $grade_id}, question_id: {_eq: $question_id}}) {
    affected_rows
  }
}
`
const DELETE_EXERCISE_GRADE = `
mutation deleteExerciseGrade($grade_id: Int, $exercise_id: Int) {
  delete_exercise_grade(where: {grade_id: {_eq: $grade_id}, exercise_id: {_eq: $exercise_id}}) {
    affected_rows
  }
}
`
const DELETE_QUESTION_EXERCISE = `
mutation deleteQuestionExercise($exercise_id: Int, $question_id: Int) {
  delete_question_exercise(where: {exercise_id: {_eq: $exercise_id}, question_id: {_eq: $question_id}}) {
    affected_rows
  }
}
`
const DELETE_LESSON_QUESTION = `
mutation deleteLessonQuestion($lesson_id: Int, $question_id: Int) {
  delete_lesson_question(where: {lesson_id: {_eq: $lesson_id}, question_id: {_eq: $question_id}}) {
    affected_rows
  }
}
`
const DELETE_PC_USER = `
mutation delete_pc_user($objWhere: pc_user_bool_exp!) {
  delete_pc_user(where: $objWhere) {
    affected_rows
  }
}
`

export default {
  // * ================ SELECT ================ *
  GET_USERS: GET_USERS,
  GET_PROFILE: GET_PROFILE,
  GET_FULLNAME: GET_FULLNAME,
  GET_USER_PUBLIC: GET_USER_PUBLIC,
  GET_GRADES: GET_GRADES,
  GET_GRADE_ID: GET_GRADE_ID,
  GET_SCHOOLS: GET_SCHOOLS,
  GET_SCHOOL_ID: GET_SCHOOL_ID,
  GET_SUBJECTS: GET_SUBJECTS,
  GET_SUBJECTS2: GET_SUBJECTS2,
  GET_ACHIEVES: GET_ACHIEVES,
  GET_HIGHLIGHT_USER: GET_HIGHLIGHT_USER,
  GET_LESSONS: GET_LESSONS,
  GET_LESSONS_FILTER: GET_LESSONS_FILTER,
  GET_CLASS_LESSON: GET_CLASS_LESSON,
  GET_FOLLOWING: GET_FOLLOWING,
  GET_FOLLOWED: GET_FOLLOWED,
  GET_STRENGTH: GET_STRENGTH,
  GET_SUBJECT_USER: GET_SUBJECT_USER,
  COUNT_EMAIL_ACCOUNT: COUNT_EMAIL_ACCOUNT,
  GET_CATEGORY: GET_CATEGORY,
  COUNT_POINT_USER: COUNT_POINT_USER,
  GET_POINTS_USER: GET_POINTS_USER,
  GET_BEEPOINT_TOP3: GET_BEEPOINT_TOP3,
  GET_BEEPOINT_RANK_USER: GET_BEEPOINT_RANK_USER,
  GET_RANK_USER: GET_RANK_USER,
  GET_PRIVATE_COMMUNITY: GET_PRIVATE_COMMUNITY,
  GET_PRIVATE_COMMUNITY_ALL: GET_PRIVATE_COMMUNITY_ALL,
  GET_FIRST_LESSON: GET_FIRST_LESSON,
  GET_FIRST_LESSON2: GET_FIRST_LESSON2,
  GET_USER_SAME_RANK: GET_USER_SAME_RANK,
  GET_CLASS_IN_PC: GET_CLASS_IN_PC,
  GET_NOTIFY_USER: GET_NOTIFY_USER,
  GET_RANK: GET_RANK,
  GET_PC_TO_USER: GET_PC_TO_USER,
  GET_PC_OF_USER: GET_PC_OF_USER,
  GET_GRADE_TO_PC: GET_GRADE_TO_PC,
  GET_RELATION_USER: GET_RELATION_USER,
  GET_RELATIONS_FILTER: GET_RELATIONS_FILTER,
  GET_RELATIONS_FILTER_CONDITION: GET_RELATIONS_FILTER_CONDITION,
  GET_CATEGORY_FILTER: GET_CATEGORY_FILTER,
  GET_CATEGORY_QUESTION_FILTER: GET_CATEGORY_QUESTION_FILTER,
  GET_CATEGORY_EXERCISE_FILTER: GET_CATEGORY_EXERCISE_FILTER,
  GET_CLASSES_WITH_SUBJECT: GET_CLASSES_WITH_SUBJECT,
  GET_USER_LINK: GET_USER_LINK,
  CHECK_LINK_USER: CHECK_LINK_USER,
  CHECK_SENT_REQUEST_EXIST: CHECK_SENT_REQUEST_EXIST,
  GET_CLASSES_OF_PC: GET_CLASSES_OF_PC,
  GET_CLASSES_TO_PC: GET_CLASSES_TO_PC,
  GET_USER_JOIN_PC: GET_USER_JOIN_PC,
  GET_USER_JOIN_PC_COUNT_STATUS: GET_USER_JOIN_PC_COUNT_STATUS,
  CHECK_USER_JOIN_PC: CHECK_USER_JOIN_PC,
  GET_USER_JOIN_PC_MEMBER: GET_USER_JOIN_PC_MEMBER,
  GET_RELATION_OF_USER: GET_RELATION_OF_USER,
  GET_USER_JOIN_FIRST_LAST: GET_USER_JOIN_FIRST_LAST,
  GET_USER_PC_GROUP_STATUS: GET_USER_PC_GROUP_STATUS,
  GET_COUNT_HISTORY_USER_ACTION_PC: GET_COUNT_HISTORY_USER_ACTION_PC,
  GET_PC_USER_JOIN_STUDENT: GET_PC_USER_JOIN_STUDENT,
  GET_CLASS_USER_JOIN_STUDENT: GET_CLASS_USER_JOIN_STUDENT,
  GET_COUNT_CATEGORY_QUESTION_USED: GET_COUNT_CATEGORY_QUESTION_USED,
  GET_COUNT_CATEGORY_EXERCISE_USED: GET_COUNT_CATEGORY_EXERCISE_USED,
  GET_COUNT_CATEGORY_LESSON_USED: GET_COUNT_CATEGORY_LESSON_USED,
  CHECK_EXERCISE_USER_EXIST: CHECK_EXERCISE_USER_EXIST,
  CHECK_EXERCISE_USER_EXIST2: CHECK_EXERCISE_USER_EXIST2,
  GET_COUNT_LESSON_USED: GET_COUNT_LESSON_USED,
  GET_COUNT_QUESTION_USED: GET_COUNT_QUESTION_USED,
  GET_COUNT_EXERCISE_USED: GET_COUNT_EXERCISE_USED,
  GET_EXERCISES: GET_EXERCISES,
  GET_FIRST_QUESTION: GET_FIRST_QUESTION,
  GET_QUESTION: GET_QUESTION,
  GET_RESULTS: GET_RESULTS,
  GET_CHANNEL: GET_CHANNEL,
  GET_CLASSES_GRADE_PC: GET_CLASSES_GRADE_PC,
  GET_LESSON_PLANING_CLASSES_OF_PC: GET_LESSON_PLANING_CLASSES_OF_PC,
  GET_LESSON_PLANING_EXERCISE_CLASSES_OF_PC: GET_LESSON_PLANING_EXERCISE_CLASSES_OF_PC,
  GET_CATEGORIES_OF_USER: GET_CATEGORIES_OF_USER,
  GET_GRADES_OF_USER: GET_GRADES_OF_USER,
  CHECK_LESSON_CLASS: CHECK_LESSON_CLASS,
  GET_CATEGORIES_EXERCISE_OF_USER: GET_CATEGORIES_EXERCISE_OF_USER,
  GET_GRADES_EXERCISE_OF_USER: GET_GRADES_EXERCISE_OF_USER,
  GET_COUNT_LESSON_CLASS_IN_PC: GET_COUNT_LESSON_CLASS_IN_PC,
  GET_COUNT_LESSON_CLASS_DISTINCT_IN_PC: GET_COUNT_LESSON_CLASS_DISTINCT_IN_PC,
  GET_COUNT_EXERCISE_IN_PC: GET_COUNT_EXERCISE_IN_PC,
  GET_COUNT_EXERCISE_DISTINCT_IN_PC: GET_COUNT_EXERCISE_DISTINCT_IN_PC,
  CHECK_EXERCISE_CLASS: CHECK_EXERCISE_CLASS,
  GET_CLASSES_ME_LESSON: GET_CLASSES_ME_LESSON,
  GET_CLASSES_ME_EXERCISE: GET_CLASSES_ME_EXERCISE,
  GET_PRIVATE_COMMUNITY_USER_ALL: GET_PRIVATE_COMMUNITY_USER_ALL,
  // * ================ UPDATE ================ *
  UPDATE_PROFILE: UPDATE_PROFILE,
  UPDATE_AVATAR: UPDATE_AVATAR,
  UPDATE_COVER: UPDATE_COVER,
  UPDATE_USER_VERIFY: UPDATE_USER_VERIFY,
  UPDATE_SUBJECT: UPDATE_SUBJECT,
  UPDATE_GRADES: UPDATE_GRADES,
  UPDATE_ACHIEVES: UPDATE_ACHIEVES,
  UPDATE_USER_DEGREES: UPDATE_USER_DEGREES,
  UPDATE_LESSON: UPDATE_LESSON,
  UPDATE_LESSON2: UPDATE_LESSON2,
  UPDATE_READ_NOTIFY: UPDATE_READ_NOTIFY,
  UPDATE_LESSON_VIDEO: UPDATE_LESSON_VIDEO,
  UPDATE_RELATION_USER: UPDATE_RELATION_USER,
  UPDATE_CATEGORY: UPDATE_CATEGORY,
  UPDATE_PC_IMG: UPDATE_PC_IMG,
  UPDATE_PC: UPDATE_PC,
  UPDATE_CLASSES: UPDATE_CLASSES,
  UPDATE_CLASSES2: UPDATE_CLASSES2,
  UPDATE_CLASSES_IMG: UPDATE_CLASSES_IMG,
  UPDATE_CLASSES_APPROVAL: UPDATE_CLASSES_APPROVAL,
  UPDATE_CATEGORY_QUESTION: UPDATE_CATEGORY_QUESTION,
  UPDATE_CATEGORY_EXERCISE: UPDATE_CATEGORY_EXERCISE,
  UPDATE_QUESTION_AUDIO: UPDATE_QUESTION_AUDIO,
  UPDATE_QUESTION: UPDATE_QUESTION,
  UPDATE_QUESTION_DETAILS: UPDATE_QUESTION_DETAILS,
  UPDATE_ANSWER: UPDATE_ANSWER,
  UPDATE_PC_USER_ALL: UPDATE_PC_USER_ALL,
  UPDATE_CHANNEL: UPDATE_CHANNEL,
  UPDATE_EXERCISE: UPDATE_EXERCISE,
  UPDATE_EXERCISE_USER: UPDATE_EXERCISE_USER,
  UPDATE_LESSON_PLANNING: UPDATE_LESSON_PLANNING,
  UPDATE_LESSON_CLASSES: UPDATE_LESSON_CLASSES,
  UPDATE_EXERCISE_CLASS: UPDATE_EXERCISE_CLASS,
  UPDATE_EXERCISE_PUBLIC: UPDATE_EXERCISE_PUBLIC,
  // * ================ CREATE ================ *
  CREATE_USER: CREATE_USER,
  CREATE_USER_SUBJECT: CREATE_USER_SUBJECT,
  CREATE_SUBJECT: CREATE_SUBJECT,
  CREATE_USER_GRADE: CREATE_USER_GRADE,
  CREATE_GRADES: CREATE_GRADES,
  CREATE_ACHIEVES: CREATE_ACHIEVES,
  CREATE_LESSON: CREATE_LESSON,
  CREATE_CATEGORY: CREATE_CATEGORY,
  CREATE_CATEGORY_QUESTION: CREATE_CATEGORY_QUESTION,
  CREATE_CATEGORY_EXERCISE: CREATE_CATEGORY_EXERCISE,
  CREATE_RELATION: CREATE_RELATION,
  CREATE_PC: CREATE_PC,
  CREATE_CLASSES: CREATE_CLASSES,
  CREATE_QUESTION: CREATE_QUESTION,
  CREATE_QUESTION_DETAILS: CREATE_QUESTION_DETAILS,
  CREATE_LESSON_QUESTION: CREATE_LESSON_QUESTION,
  CREATE_QUESTION_GRADE: CREATE_QUESTION_GRADE,
  CREATE_ANSWER: CREATE_ANSWER,
  CREATE_EXERCISE: CREATE_EXERCISE,
  CREATE_EXERCISE_USER: CREATE_EXERCISE_USER,
  CREATE_EXERCISE_GRADE: CREATE_EXERCISE_GRADE,
  CREATE_QUESTION_EXERCISE: CREATE_QUESTION_EXERCISE,
  CREATE_USER_JOIN_TO_PC: CREATE_USER_JOIN_TO_PC,
  CREATE_PC_HISTORY: CREATE_PC_HISTORY,
  CREATE_CHANNEL: CREATE_CHANNEL,
  CREATE_LESSON_CLASSES: CREATE_LESSON_CLASSES,
  CREATE_LESSON_GRADE: CREATE_LESSON_GRADE,
  CREATE_EXERCISE_CLASSES: CREATE_EXERCISE_CLASSES,
  // * ================ DELETE ================ *
  DELETE_SUBJECT: DELETE_SUBJECT,
  DELETE_GRADES: DELETE_GRADES,
  DELETE_ACHIEVES: DELETE_ACHIEVES,
  DELETE_LESSON: DELETE_LESSON,
  DELETE_RELATION: DELETE_RELATION,
  DELETE_CATEGORY: DELETE_CATEGORY,
  DELETE_CLASSES: DELETE_CLASSES,
  DELETE_LESSON_CLASS: DELETE_LESSON_CLASS,
  DELETE_QUESTION_GRADE: DELETE_QUESTION_GRADE,
  DELETE_EXERCISE_GRADE: DELETE_EXERCISE_GRADE,
  DELETE_QUESTION_EXERCISE: DELETE_QUESTION_EXERCISE,
  DELETE_LESSON_QUESTION: DELETE_LESSON_QUESTION,
  DELETE_PC_USER: DELETE_PC_USER
}



// WEBPACK FOOTER //
// ./src/components/Model/graphql.js